/* eslint-disable max-statements */
import { useCallback } from 'react'
import { useProductOptionSequenceContext } from '../../../../../contexts/productOptionSequence.context'
import nrLogger from '../../../../../helpers/nrLogger'
import shoppingCartV2API from '../../../api'
import { useShoppingCartContext } from '../../../providers/ShoppingCartProvider'
import executeGTM from './executeGTM'
import StopWatch from '../../../logging/StopWatch'
import trackApplyCouponValidationInCartRemoveItem from '../../../logging/gtm/trackApplyCouponValidationInCartRemoveItem'
import useWmoEnabled from '../../../../../hooks/useWmoEnabled'
import updateCartCounter from '../../../logging/header/updateCartCounter'

const useRemoveItemsCallback = setRemovingItem => {
  const {
    getCartId,
    getIdentifier,
    setCart,
    shouldShowLoader,
    cartData,
    setItemProductIdBeingUpdated,
  } = useShoppingCartContext()

  const productOptionSequenceData = useProductOptionSequenceContext()
  const { skuArray = [] } = productOptionSequenceData
  const isWmoEnabled = useWmoEnabled()

  return useCallback(
    async items => {
      shouldShowLoader(true)

      if (setRemovingItem) {
        setRemovingItem(true)
      }

      try {
        const [currentItem] = items
        if (currentItem?.product?.productId) {
          setItemProductIdBeingUpdated(currentItem.product.productId)
        }
        const identifier = getIdentifier()
        const cartId = getCartId()
        const pItems = items.map(
          item => ({
            product: {
              productId: item.product.productId,
              ...item?.modifiers?.vendorData?.vendorSku && { vendorSku: item?.modifiers.vendorData.vendorSku },
            },
          }),
        )
        const timer = new StopWatch()
        timer.start()
        const res = await shoppingCartV2API.items.remove(identifier, cartId, pItems)
        timer.stop()

        trackApplyCouponValidationInCartRemoveItem(res, timer.getElapsed())
        updateCartCounter(res);
        setCart(res)
        shouldShowLoader(false)

        executeGTM(items, skuArray, isWmoEnabled)
        return res
      } catch (error) {
        // Check if item has been removed from cart already. 404 error response
        // Ref: PPP-1292
        if (error instanceof Error && error.message.includes('404')) {
          const productIdstoRemove = items?.map(item => item?.product?.productId)
          const itemsKept = cartData.items?.filter(item => !productIdstoRemove.includes(item?.product?.productId))
          const updatedCartData = {
            ...cartData,
            items: itemsKept,
          }
          setCart(updatedCartData)
          // eslint-disable-next-line no-console
          console.log('Item has been removed from cart already')
        }

        nrLogger.error('ShoppingCartV2.useRemoveItemsCallback.error', error)
        if (setRemovingItem) {
          setRemovingItem(false)
        }
      }

      shouldShowLoader(false)

      if (setRemovingItem) {
        setRemovingItem(false)
      }

      return null
    },
    [
      cartData,
      getCartId,
      getIdentifier,
      isWmoEnabled,
      setCart,
      setRemovingItem,
      shouldShowLoader,
      skuArray,
      setItemProductIdBeingUpdated,
    ],
  )
}

export default useRemoveItemsCallback
